import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { NewApiKeyPage } from './new-api-key.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: NewApiKeyPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [NewApiKeyPage],
})
export class NewApiKeyPageModule {}
